import { useRecentTradesStoreBase } from './recentTrades.store';
import { RecentTradesStore } from './recentTrades.types';

// ======= Store Selectors - To be used with functions outside react (NON-REACTIVE) =======

// #region Store Selectors

const recentTradesStoreSelector = () => useRecentTradesStoreBase.getState().state;

const recentTradesSelector = () => recentTradesStoreSelector().trades;

const lastTradedObjectSelector = () => recentTradesStoreSelector().lastTrade;

const lastTradedPriceSelector = () => lastTradedObjectSelector()?.price;

const lastTradedPriceMovementSelector = () => lastTradedObjectSelector()?.price_movement;

// #endregion Store Selectors

// ========  Data Selectors - To be used with components (Reactive Data) ========
// Ex: const tradeMoment = useRecentTradesStoreBase(selectLastTradedPriceMovement);
// #region Reactive Data Selectors

const selectLastTradedPrice = (store: RecentTradesStore) => store.state.lastTrade?.price;

const selectLastTradedPriceMovement = (store: RecentTradesStore) =>
  store.state.lastTrade?.price_movement;

const selectRecentTrades = (store: RecentTradesStore) => store.state.trades;

const selectLtpInUsd = (spotPriceUsd: number) => (store: RecentTradesStore) => {
  const lastTradePrice = store.state.lastTrade?.price ?? 0;
  const lstToUSD = parseFloat(String(lastTradePrice)) * spotPriceUsd;
  if (lstToUSD < 1) return `$${lstToUSD.toFixed(3)}`;
  return `$${lstToUSD.toFixed(2)}`;
};

// #endregion Reactive Data Selectors

export {
  // #region Non Reactive Selectors
  recentTradesStoreSelector,
  recentTradesSelector,
  lastTradedObjectSelector,
  lastTradedPriceSelector,
  lastTradedPriceMovementSelector,
  // #endregion

  // #region Reactive Selectors (use with useRecentTradesStoreBase)
  selectLastTradedPrice,
  selectLastTradedPriceMovement,
  selectRecentTrades,
  selectLtpInUsd,
  // #endregion Reactive Selectors
};
